const CarAlert = require('./CarAlert');
const SeverityLevel = require('./SeverityLevel');

module.exports = {
  [CarAlert.MAINTENANCE_ODOMETER_EXCEEDED]: SeverityLevel.HIGH,
  [CarAlert.MAINTENANCE_DATE_EXCEEDED]: SeverityLevel.HIGH,
  [CarAlert.OTHER_FAILING_SYSTEM]: SeverityLevel.VERY_HIGH,
  [CarAlert.EXCESSIVE_WATER_TEMPERATURE]: SeverityLevel.HIGH,
  [CarAlert.LOW_COOLING_LIQUID_LEVEL]: SeverityLevel.MEDIUM,
  [CarAlert.EXCESSIVE_OIL_TEMPERATURE]: SeverityLevel.MEDIUM,
  [CarAlert.LOW_ENGINE_OIL_LEVEL]: SeverityLevel.MEDIUM,
  [CarAlert.ENGINE_OIL_PRESSURE_ALERT]: SeverityLevel.HIGH,
  [CarAlert.GEARBOX_FAILURE]: SeverityLevel.VERY_HIGH,
  [CarAlert.EXCESSIVE_GEARBOX_OIL_TEMPERATURE]: SeverityLevel.HIGH,
  [CarAlert.TRANSMISSION_FAULT]: SeverityLevel.MEDIUM,
  [CarAlert.HYDRAULIC_PRESSURE_OR_BRAKE_FLUID_INSUFFICIENT]: SeverityLevel.MEDIUM,
  [CarAlert.BRAKING_OIL_LEVEL_LOW]: SeverityLevel.MEDIUM,
  [CarAlert.ENGINE_CONTROL_SYSTEM_FAILURE]: SeverityLevel.VERY_HIGH,
  [CarAlert.WATER_IN_DIESEL_FILTER]: SeverityLevel.MEDIUM,
  [CarAlert.ANTI_POLLUTION_SYSTEM_FAILURE]: SeverityLevel.LOW,
  [CarAlert.LOW_DIESEL_ADDITIVE]: SeverityLevel.MEDIUM,
  [CarAlert.BATTERY_CHARGE_OR_POWER_SUPPLY_FAILURE]: SeverityLevel.MEDIUM,
  [CarAlert.SECONDARY_BATTERY_LOW_CHARGE]: SeverityLevel.MEDIUM,
  [CarAlert.DSG_FAILING]: SeverityLevel.MEDIUM,
  [CarAlert.BRAKE_PADS_EXCESSIVE_WEAR]: SeverityLevel.MEDIUM,
  [CarAlert.BRAKING_SYSTEM_FAILURE]: SeverityLevel.HIGH,
  [CarAlert.PARKING_BRAKE_CONTROL_FAILING]: SeverityLevel.MEDIUM,
  [CarAlert.PARKING_BRAKE_OR_HILL_HOLDER_FAILURE]: SeverityLevel.MEDIUM,
  [CarAlert.AUTO_PARKING_BRAKE_CONTROL_ACTIVATED]: SeverityLevel.LOW,
  [CarAlert.ABS_FAILURE]: SeverityLevel.MEDIUM,
  [CarAlert.ESP_FAILURE]: SeverityLevel.MEDIUM,
  [CarAlert.POWER_STEERING_FAILURE]: SeverityLevel.MEDIUM,
  [CarAlert.SUSPENSION_FAILURE]: SeverityLevel.MEDIUM,
  [CarAlert.SUSPENSION_FAILURE_REDUCE_SPEED]: SeverityLevel.MEDIUM,
  [CarAlert.TIRE_PRESSURE_SENSOR_FAILURE]: SeverityLevel.MEDIUM,
  [CarAlert.LOW_TIRE_PRESSURE]: SeverityLevel.MEDIUM,
  [CarAlert.FLAT_TIRE]: SeverityLevel.MEDIUM,
  [CarAlert.TIRE_PRESSURE_MONITORING_FAILURE]: SeverityLevel.MEDIUM,
  [CarAlert.SHOCK_SENSOR_FAILING]: SeverityLevel.MEDIUM,
  [CarAlert.AIRBAG_OR_SAFETY_BELT_FAILURE]: SeverityLevel.VERY_HIGH,
  [CarAlert.ANTI_POLLUTION_FAILURE_ENGINE_START_IMPOSSIBLE]: SeverityLevel.MEDIUM,
  [CarAlert.DIRECTIONAL_LIGHT_FAILURE]: SeverityLevel.MEDIUM,
  [CarAlert.ELECTRONIC_LOCK_FAILURE]: SeverityLevel.MEDIUM,
  [CarAlert.SPEED_CONTROL_FAILURE]: SeverityLevel.MEDIUM,
  [CarAlert.LOW_FUEL_LEVEL]: SeverityLevel.MEDIUM,
  [CarAlert.PARTICLE_FILTER_MIGHT_BE_CLOGGED]: SeverityLevel.MEDIUM,
  [CarAlert.AUTOMATIC_LIGHTS_SETTING_FAILURE]: SeverityLevel.MEDIUM,
  [CarAlert.LOW_WASHER_FLUID]: SeverityLevel.LOW,
  [CarAlert.FLAT_TIRE_FRONT_RIGHT]: SeverityLevel.HIGH,
  [CarAlert.FLAT_TIRE_REAR_LEFT]: SeverityLevel.HIGH,
  [CarAlert.FLAT_TIRE_REAR_RIGHT]: SeverityLevel.HIGH,
  [CarAlert.SIDELIGHTS_FAILURE_FRONT_LEFT]: SeverityLevel.MEDIUM,
  [CarAlert.SIDELIGHTS_FAILURE_FRONT_RIGHT]: SeverityLevel.MEDIUM,
  [CarAlert.SIDELIGHTS_FAILURE_REAR_RIGHT]: SeverityLevel.MEDIUM,
  [CarAlert.SIDELIGHTS_FAILURE_REAR_LEFT]: SeverityLevel.MEDIUM,
  [CarAlert.DIPPED_BEAM_HEADLAMPS_FAILURE_FRONT_RIGHT]: SeverityLevel.MEDIUM,
  [CarAlert.DIPPED_BEAM_HEADLAMPS_FAILURE_FRONT_LEFT]: SeverityLevel.MEDIUM,
  [CarAlert.HEADLIGHTS_FAILURE_RIGHT]: SeverityLevel.MEDIUM,
  [CarAlert.HEADLIGHTS_FAILURE_LEFT]: SeverityLevel.MEDIUM,
  [CarAlert.STOP_LIGHT_FAILURE_RIGHT]: SeverityLevel.MEDIUM,
  [CarAlert.STOP_LIGHT_FAILURE_LEFT]: SeverityLevel.MEDIUM,
  [CarAlert.FOG_LIGHT_FAILURE_REAR_LEFT]: SeverityLevel.MEDIUM,
  [CarAlert.FOG_LIGHT_FAILURE_FRONT_RIGHT]: SeverityLevel.MEDIUM,
  [CarAlert.FOG_LIGHT_FAILURE_REAR_RIGHT]: SeverityLevel.MEDIUM,
  [CarAlert.FOG_LIGHT_FAILURE_FRONT_LEFT]: SeverityLevel.MEDIUM,
  [CarAlert.TURN_SIGNAL_FAILURE_FRONT_RIGHT]: SeverityLevel.MEDIUM,
  [CarAlert.TURN_SIGNAL_FAILURE_REAR_RIGHT]: SeverityLevel.MEDIUM,
  [CarAlert.TURN_SIGNAL_FAILURE_FRONT_LEFT]: SeverityLevel.MEDIUM,
  [CarAlert.TURN_SIGNAL_FAILURE_REAR_LEFT]: SeverityLevel.MEDIUM,
  [CarAlert.REVERSE_LIGHT_FAILURE_RIGHT]: SeverityLevel.MEDIUM,
  [CarAlert.REVERSE_LIGHT_FAILURE_LEFT]: SeverityLevel.MEDIUM,
  [CarAlert.ACTIVE_HOOD_FAILURE]: SeverityLevel.MEDIUM,
  [CarAlert.PARKING_ASSISTANCE_SYSTEM_FAILURE]: SeverityLevel.LOW,
  [CarAlert.PARKING_SPACE_MEASURING_SYSTEM_FAILURE]: SeverityLevel.LOW,
  [CarAlert.LOW_TIRE_PRESSURE_FRONT_LEFT]: SeverityLevel.MEDIUM,
  [CarAlert.LOW_TIRE_PRESSURE_FRONT_RIGHT]: SeverityLevel.MEDIUM,
  [CarAlert.LOW_TIRE_PRESSURE_REAR_RIGHT]: SeverityLevel.MEDIUM,
  [CarAlert.LOW_TIRE_PRESSURE_REAR_LEFT]: SeverityLevel.MEDIUM,
  [CarAlert.SEATBELT_PASSENGER_UNBUCKLED_FRONT_RIGHT]: SeverityLevel.MEDIUM,
  [CarAlert.SEATBELT_PASSENGER_UNBUCKLED_REAR_LEFT]: SeverityLevel.MEDIUM,
  [CarAlert.SEATBELT_PASSENGER_UNBUCKLED_REAR_MIDDLE]: SeverityLevel.MEDIUM,
  [CarAlert.SEATBELT_PASSENGER_UNBUCKLED_REAR_RIGHT]: SeverityLevel.MEDIUM,
  [CarAlert.CROSSING_LINE_SYSTEM_ALERT_FAILURE]: SeverityLevel.LOW,
  [CarAlert.ANTI_REVERSE_SYSTEM_FAILING]: SeverityLevel.MEDIUM,
  [CarAlert.POWER_STEERING_ASSISTANCE_FAILURE]: SeverityLevel.MEDIUM,
  [CarAlert.ALERT_COOLANT_TEMP]: SeverityLevel.MEDIUM,
  [CarAlert.ALERT_BRAKE_FLUID]: SeverityLevel.MEDIUM,
  [CarAlert.STEERING_FAULT]: SeverityLevel.MEDIUM,
  [CarAlert.FRONT_LEFT_DOOR_OPEN_HIGH_SPEED]: SeverityLevel.MEDIUM,
  [CarAlert.FRONT_RIGHT_DOOR_OPEN_HIGH_SPEED]: SeverityLevel.MEDIUM,
  [CarAlert.REAR_LEFT_DOOR_OPEN_HIGH_SPEED]: SeverityLevel.MEDIUM,
  [CarAlert.REAR_RIGHT_DOOR_OPEN_HIGH_SPEED]: SeverityLevel.MEDIUM,
  [CarAlert.TRUNK_OPEN_HIGH_SPEED]: SeverityLevel.MEDIUM,
  [CarAlert.TRUNK_WINDOW_OPEN]: SeverityLevel.MEDIUM,
  [CarAlert.BATTERY_LEVEL_FAULT]: SeverityLevel.MEDIUM,
  [CarAlert.ENGINE_FAULT]: SeverityLevel.MEDIUM,
  [CarAlert.PREHEATING_DEACTIVATED_BATTERY_TOO_LOW]: SeverityLevel.MEDIUM,
  [CarAlert.PREHEATING_DEACTIVATED_FUEL_LEVEL_TOO_LOW]: SeverityLevel.MEDIUM,
  [CarAlert.CHECK_THE_BRAKE_LAMP]: SeverityLevel.MEDIUM,
  [CarAlert.RETRACTABLE_ROOF_MECHANISM_FAULT]: SeverityLevel.MEDIUM,
  [CarAlert.ALERT_STEERING_LOCK]: SeverityLevel.MEDIUM,
  [CarAlert.ROOF_OPERATION_IMPOSSIBLE_TEMPERATURE_TOO_HIGH]: SeverityLevel.MEDIUM,
  [CarAlert.ROOF_OPERATION_IMPOSSIBLE_START_ENGINE]: SeverityLevel.MEDIUM,
  [CarAlert.ROOF_OPERATION_IMPOSSIBLE_APPLY_PARKING_BREAK]: SeverityLevel.MEDIUM,
  [CarAlert.HYBRID_SYSTEM_FAULT]: SeverityLevel.MEDIUM,
  [CarAlert.HYBRID_SYSTEM_FAULT_REPAIRED_THE_VEHICLE]: SeverityLevel.MEDIUM,
  [CarAlert.BATTERY_KEY_ALARM]: SeverityLevel.MEDIUM,
  [CarAlert.PREHEATING_DEACTIVATED_SET_THE_CLOCK]: SeverityLevel.MEDIUM,
  [CarAlert.TRAILER_CONNECTION_FAULT]: SeverityLevel.MEDIUM,
  [CarAlert.LIMITED_VISIBILITY_AIDS_CAMERA]: SeverityLevel.MEDIUM,
  [CarAlert.ELECTRIC_MODE_NOT_AVAILABLE]: SeverityLevel.MEDIUM,
  [CarAlert.WHEEL_PRESSURE_FAULT]: SeverityLevel.MEDIUM,
  [CarAlert.CHECK_SIDE_LAMPS]: SeverityLevel.MEDIUM,
  [CarAlert.FRONT_FOGLIGHT_FAULT]: SeverityLevel.MEDIUM,
  [CarAlert.REAR_FOGLIGHT_FAULT]: SeverityLevel.MEDIUM,
  [CarAlert.CHECK_REVERSING_LAMP]: SeverityLevel.MEDIUM,
  [CarAlert.ADJUST_TYRE_PRESSURE]: SeverityLevel.MEDIUM,
  [CarAlert.PLACE_GEAR_BOX_TO_P]: SeverityLevel.MEDIUM,
  [CarAlert.RISK_OF_ICE]: SeverityLevel.LOW,
  [CarAlert.FRONT_RIGHT_DOOR_OPEN]: SeverityLevel.MEDIUM,
  [CarAlert.FRONT_LEFT_DOOR_OPEN]: SeverityLevel.MEDIUM,
  [CarAlert.REAR_RIGHT_DOOR_OPEN]: SeverityLevel.MEDIUM,
  [CarAlert.REAR_LEFT_DOOR_OPEN]: SeverityLevel.MEDIUM,
  [CarAlert.TRUNK_OPEN]: SeverityLevel.LOW,
  [CarAlert.BOOT_OPEN]: SeverityLevel.MEDIUM,
  [CarAlert.REAR_SCREEN_OPEN]: SeverityLevel.MEDIUM,
  [CarAlert.ACTIVE_SPOILER_FAULT]: SeverityLevel.MEDIUM,
  [CarAlert.AUTOMATIC_BRAKING_SYSTEM_FAULT]: SeverityLevel.MEDIUM,
  [CarAlert.DIRECTIONAL_HEADLAMPS_FAULT]: SeverityLevel.MEDIUM,
  [CarAlert.SUSPENSION_FAULT_LIMIT_TO90KM]: SeverityLevel.MEDIUM,
  [CarAlert.FRONT_LEFT_TYRE_NOT_MONITORED]: SeverityLevel.MEDIUM,
  [CarAlert.FRONT_RIGHT_TYRE_NOT_MONITORED]: SeverityLevel.MEDIUM,
  [CarAlert.REAR_RIGHT_TYRE_NOT_MONITORED]: SeverityLevel.MEDIUM,
  [CarAlert.REAR_LEFT_TYRE_NOT_MONITORED]: SeverityLevel.MEDIUM,
  [CarAlert.LANE_DEPARTURE_FAULT]: SeverityLevel.MEDIUM,
  [CarAlert.TYRE_UNDER_INFLATION]: SeverityLevel.MEDIUM,
  [CarAlert.SPARE_WHEEL_FITTED_DRIVING_AIDS_DEACTIVATED]: SeverityLevel.MEDIUM,
  [CarAlert.AUTOMATIC_BRAKING_DEACTIVATED]: SeverityLevel.MEDIUM,
  [CarAlert.TOP_UP_AD_BLUE]: SeverityLevel.MEDIUM,
  [CarAlert.LONG_PUSH_TO_UNLOCK_TANK_FAULT]: SeverityLevel.MEDIUM,
};
